// extracted by mini-css-extract-plugin
export default {"list":"optimist_list__-irFI","arrow_icon":"optimist_arrow_icon__26dOQ","subtitle":"optimist_subtitle__PvPts"};